"use client";

import { useMemo } from "react";

import { PublicTrackingDashboard } from "@/components/public-tracking/dashboard/PublicTrackingDashboard";
import { trackingEventStops } from "@/utils/publicTracking/scanJourney";
import type { PublicTrackingStatus } from "@/utils/publicTracking/types";
import { useScanJourneyMap } from "@/utils/publicTracking/useScanJourneyMap";

interface PublicTrackingPreviewProps {
  data: PublicTrackingStatus;
  label: string;
}

/**
 * Renders the public tracking dashboard against a fixture for QA / design
 * review. Wires the same geocode + map preload as the real form so the
 * preview matches production behavior pixel-for-pixel — only the fetch is
 * skipped. A small banner labels the preview as sample data.
 */
export function PublicTrackingPreview({
  data,
  label,
}: PublicTrackingPreviewProps) {
  const stops = useMemo(() => trackingEventStops(data), [data]);
  const journey = useScanJourneyMap(stops);

  return (
    <div className="space-y-4">
      <div
        role="status"
        className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-800/40 dark:bg-amber-950/30 dark:text-amber-100"
      >
        <span className="font-semibold">QA preview</span> &mdash; {label}.
        Sample data, not a real tracking result.
      </div>
      <PublicTrackingDashboard data={data} journey={journey} />
    </div>
  );
}
